<template>
  <b-form-group :label="computedLabel" label-for="device-type-select">
    <multiselect
      id="device-type-select"
      placeholder="-"
      :searchable="false"
      :show-no-results="true"
      :allowEmpty="true"
      :disabled="loading"
      open-direction="bottom"
      :options="options"
      v-model="selectedOption"
      track-by="id"
      label="commercial_name"
    >

      <template slot="clear">
        <div
          class="multiselect__clear"
          v-if="value"
          @mousedown.prevent.stop="clearValue"
        ></div>
      </template>

      <span slot="noOptions">
      {{ $t('No device types available') }}
    </span>

    </multiselect>
  </b-form-group>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import {sortBy} from "lodash";

export default {
  name: "DeviceTypesSelect",
  components: {
    Multiselect,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    tLabel: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String | Number | null,
      required: true,
    },
    variant: {
      type: String,
      required: true,
      validator: function (value) {
        return ['xDealer', 'xAdmin'].includes(value);
      }
    }
  },
  data() {
    return {
      loading: true,
      selectedOption: null,
      options: [],
      ready: false
    }
  },
  mounted() {
    this.fetchOptions();
  },
  methods: {
    fetchOptions() {
      const url = this.variant === 'xAdmin'
        ? `${this.$store.getters.getAppUrl}/admin/api/v2/device-types?sort_by=commercial_name&order_by=asc`
        : `${this.$store.getters.getAppUrl}/dealer/api/v2/device-types?sort_by=commercial_name&order_by=asc`;

      axios
        .get(url)
        .then((response) => {
          this.options = sortBy(response.data.data, 'commercial_name');
        })
        .catch(function (error) {
          console.log(error.stack);
        })
        .finally(() => {
          this.loading = false;
          this.ready = true;
        });
    },
    clearValue() {
      this.$emit("input", null);
    },
    findByValue(value) {
      if (!value) {
        return null;
      }

      return this.options.find(options => value.toString() === options?.id?.toString()) || null;
    }
  },
  computed: {
    computedLabel() {
      return this.tLabel ? this.$t(this.tLabel) : this.label;
    },
  },
  watch: {
    ready(value) {
      this.$emit("ready", value);
    },
    selectedOption(newValue) {
      this.$emit("input", newValue ? newValue.id : null);
    },
    value(newValue) {
      this.selectedOption = this.findByValue(newValue);
    }
  }
};
</script>
